import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'TabbedCards' })(
  ({ breakpoints, spacing }) => ({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
    },
    tabs2up: {
      [breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    tabs3up: {
      [breakpoints.up('md')]: {
        display: 'none',
      },
    },
  })
);

export default useStyles;
